import OCTipoPago from "./OCTipoPagoContainer"
export default OCTipoPago;